import axiosInstance from "../../../../interceptors/axiosInstance";
import { AxiosResponse } from "axios";
import { ResponseHeaderActDeuda } from "../models";

const GetEncabezadosAct = async (idSol: number, idOpe: number) => {
    const response: Promise<AxiosResponse<ResponseHeaderActDeuda>> = axiosInstance.get(`siscred-api-reportes/v1/portabilidad/obtener-encabezado-act?idSol=${idSol}&idOpe=${idOpe}&tipoCert=ACTINS`);
    return response;
}

export {
    GetEncabezadosAct,
};